<kp-screen-email-signup-base headerTitle="Didn't Receive a Code?">
  <div icon class="header-icon">
    <svg-icon src="/assets/icons/question-filled-circle.svg"></svg-icon>
  </div>
  <div instructions class="instructions">
    <p class="instruction">
      If you don’t receive an email with your access code after a few minutes, here are a few things you can try.
    </p>
    <ul class="instruction-list">
      <li class="instruction-list-item">Check your email address for typos</li>
      <li class="instruction-list-item">Check your spam folder</li>
      <li class="instruction-list-item">Make sure you’re looking in the right email account (e.g. work/personal)</li>
    </ul>
    <p class="instruction">
      If you already have a Kumanu account with that email address,
      <a routerLink="/login" class="link">sign in</a>
      instead.
    </p>
    <!-- Adding comment to remove extra space that Prettier adds around the link and before the period -->
    <!-- prettier-ignore -->
    <p class="instruction">If you’re still having trouble, email us at <a href="mailto:support@kumanu.com?subject=Verifying Email Support Request" class="link" title="support@kumanu.com" target="_blank">support@kumanu.com</a>.
    </p>
  </div>
  <ng-container footer>
    <button kutilBackButton class="button button-pill button-code-resend button-submit" (click)="resendCode()">
      Resend Code
    </button>
  </ng-container>
</kp-screen-email-signup-base>
